/**
 * (c) 2020 KPMG LLP, a Delaware limited liability partnership
 * and the U.S. member firm of the KPMG network of independent member
 * firms affiliated with KPMG International Cooperative ("KPMG
 * International"), a Swiss entity. All rights reserved.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { PageTitleComponent } from './components/page-title/page-title.component';
import { GoBackComponent } from './components/go-back/go-back.component';
import { RouterModule } from '@angular/router';
import { A11yModule } from '@angular/cdk/a11y';
import { MaterialModule } from './material.module';
import { NPS10ScalePipe } from './services/pipes/nps-10scale-pipe';// Import the NPS10ScalePipe
import { ToggleButtonComponent } from './components/toggle-button/toggle-button.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { FooterComponent } from './components/footer/footer.component';
import { BackArrowComponent } from './components/back-arrow/back-arrow.component';
import { CapitalizePipe } from './services/pipes/capitalize.pipe';

@NgModule({
  declarations: [
    PageTitleComponent,
    GoBackComponent,
    NPS10ScalePipe,
    ToggleButtonComponent,
    FooterComponent,
    BackArrowComponent,
    CapitalizePipe
  ],
  imports: [
    CommonModule,
    RouterModule,
    A11yModule,
    MatButtonToggleModule,
    FormsModule
  ],
  exports: [
    FlexLayoutModule,
    ReactiveFormsModule,
    PageTitleComponent,
    GoBackComponent,
    A11yModule,
    MaterialModule,
    FormsModule,
    NPS10ScalePipe,
    ToggleButtonComponent,
    FooterComponent,
    BackArrowComponent,
    CapitalizePipe
  ]
})
export class SharedModule {}
